/** Couleurs par défaut (charte Sportips) */
export const DEFAULT_MODULE_COLORS = {
  primary: '#F29200',
  primary_dark: '#cf7c00',
  darkblue: '#14213D',
  /** Texte courant (Vuetify `on-background`, `--v-theme-on-background`) */
  text_color: '#14213D',
  /** Fond des `.spo-card`, `.spo-action-card`, `.bg-spo-light`, etc. (ex-`$spo-light`) */
  card_background: '#f6f8fd',
  card_background_hover: '#eaecf0',
  /** Bordures cartes, en-têtes `.bg-spo-blue-grey` (ex-`$spo-blue-grey`) */
  card_blue_grey: '#e9edf4',
};

/** Clés personnalisables en admin (labels pour l’interface) */
export const PERSONALIZABLE_COLOR_KEYS = [
  { key: 'primary', label: 'Couleur primaire orange', hint: 'Boutons, icones' },
  { key: 'darkblue', label: 'Couleur secondaire Bleu foncé', hint: 'Boutons, icones, couleur dark' },
  { key: 'title_color', label: 'Couleur des titres', hint: 'Classes .text-h1 à .text-h6' },
  { key: 'text_color', label: 'Couleur du texte', hint: 'Texte courant et on-background Vuetify' },
  { key: 'card_background', label: 'Fond des cartes', hint: 'Cartes et boutons fond clair' },
  { key: 'card_blue_grey', label: 'Bleu-gris cartes', hint: 'Bordures des cartes et sections accueil' },
];

function mergeNonEmpty(target, source) {
  if (!source || typeof source !== 'object') {
    return;
  }
  Object.entries(source).forEach(([key, value]) => {
    if (value != null && String(value).trim() !== '') {
      target[key] = String(value).trim();
    }
  });
}

/**
 * @param {string} baseModule - Trigramme du module (route ou module.base)
 * @param {Record<string, string>} [dbPersonalization] - Surcharges depuis nm_module_personalization
 */
function applyPrimaryDarkPair(colors, dbPersonalization) {
  const primary = dbPersonalization?.primary != null && String(dbPersonalization.primary).trim() !== '';
  if (primary) {
    colors.primary_dark = colors.primary;
    return;
  }
  const legacyPrimaryDark = dbPersonalization?.primary_dark != null
    && String(dbPersonalization.primary_dark).trim() !== '';
  if (legacyPrimaryDark) {
    colors.primary = colors.primary_dark;
  }
}

export function getModuleColors(baseModule, dbPersonalization = {}) {
  void baseModule;
  const colors = { ...DEFAULT_MODULE_COLORS };
  mergeNonEmpty(colors, dbPersonalization);
  applyPrimaryDarkPair(colors, dbPersonalization);
  return colors;
}

/** Synchronise primary_dark sur primary pour l’API et l’aperçu admin */
export function withSyncedPrimaryDark(personalization) {
  const out = { ...personalization };
  const primary = out.primary != null ? String(out.primary).trim() : '';
  out.primary = primary;
  out.primary_dark = primary;
  return out;
}
